import exportControlTiemposFormModel from './exportControlTiemposFormModel';
const {
  formField: {
    // DATOS AREA 
    from,
    to
  } 
} = exportControlTiemposFormModel;

export default {
  [from.name]: '',
  [to.name]: ''
};

